import React, { useEffect } from 'react';
import styles from './Projects.module.css';

const projects = [
  {
    title: 'Trukkify',
    description:
      'Trukkify is a smart logistics and transportation management platform that helps businesses streamline shipment tracking, contract management, document handling, and communication. The app provides real-time visibility, operational efficiency, and seamless collaboration for shippers, transporters, and supply chain stakeholders, enabling faster and more reliable logistics operations.',
    tags: ['Logistics', 'Mobile App', 'Management'],
    image: 'images/logos/twi.png',
    featured: true,
    link: 'https://trukkify.ai/en',
  },
  {
    title: 'Karsishma Global Ventures LLP',
    description:
      'At Karishma Global Ventures LLP, we are revolutionizing the future of transportation. Our cutting-edge Smart E-Mobility Solution enables you to convert your conventional petrol bike into a hybrid bike.',
    tags: ['E-Mobility', 'Hybrid Bike', 'Automotive'],
    image: 'images/logos/kgvl.png',
    link: 'https://www.kgvl.co.in/',
  },
  {
    title: 'USTRANS WORLD LOGISTICS LIMITED',
    description:
      'USTrans World Logistics is a complete freight forwarding company, providing integrated solutions for all logistics needs under one roof.',
    tags: ['Logistics', 'Freight Forwarding', 'Supply Chain'],
    image: 'images/logos/ustl.png',
    link: 'https://www.ustl.in/',
  },
  {
    title: 'Devta Gensets',
    description:
      'Devta Gensets Private Limited is a leading provider of power solutions with over three decades of experience in the industry. With a focus on quality and innovation, we partner with renowned brands to offer a wide range of gas generators.',
    tags: ['Power Solutions', 'Generators', 'Industrial'],
    image: 'images/logos/dg.png',
    link: 'https://devtagensets.com/',
  },
  {
    title: 'TWI',
    description:
      "TWI's fleet and long-term subcontractors, we provide integrated, customized, and environmentally friendly transportation solutions to major industries with a high level of technicality.",
    tags: ['Transportation', 'Logistics', 'Fleet'],
    image: 'images/logos/twi.png',
    link: 'https://twigroup.in/',
  },
  {
    title: 'KGVL Hybrid App',
    description:
      'The KGVL App is a user-friendly mobile app that helps bike owners convert their petrol bikes into hybrid bikes, allowing them to run on both petrol and electricity.',
    tags: ['Mobile App', 'Android', 'E-Mobility'],
    image: 'images/logos/kgvl.png',
    link: 'https://play.google.com/store/apps/details?id=com.tsilteam.KGVHybridSol&pcampaignid=web_share',
  },
  {
    title: 'Pure Prakrati',
    description:
      'Pure Prakruti is a user-friendly app designed to help businesses reduce carbon emissions in road logistics, promoting sustainability in an industry responsible for 27% of global emissions.',
    tags: ['Mobile App', 'Sustainability', 'Logistics'],
    image: 'images/logos/pp.png',
    link: 'https://play.google.com/store/apps/details?id=com.tsilteam.pureprakruti&pcampaignid=web_share',
  },
  {
    title: 'Winsol Hybrid Power Pvt Ltd',
    description:
      'Winsol Hybrid Power Pvt. Ltd. is a renewable energy technology company specializing in hybrid solar and wind power solutions. The company develops innovative clean-energy systems that generate sustainable electricity, reduce carbon footprints, and support smart infrastructure development for industries, businesses, and public sectors across India.',
    tags: ['Renewable Energy', 'Solar Power', 'Wind Power'],
    image: 'images/logos/winsol.jpg',
    link: 'https://winsolhybrid.com/',
  },
  {
    title: 'Global Federation of Green Mobility (GFGM)',
    description:
      'Global Federation of Green Mobility (GFGM) is a global platform dedicated to promoting sustainable transportation, clean energy adoption, and environmentally responsible mobility solutions. The organization brings together industry leaders, policymakers, technology innovators, academic institutions, and sustainability advocates to accelerate the transition toward a greener and more sustainable future.',
    tags: ['Green Mobility', 'Sustainability', 'Platform'],
    image: 'images/logos/gfgm.png',
    link: 'https://globalgreenmobilty.com/',
  },
  {
    title: 'Trukkify',
    description:
      'Trukkify is a smart logistics and transportation management platform that helps businesses streamline shipment tracking, contract management, document handling, and communication. The app provides real-time visibility, operational efficiency, and seamless collaboration for shippers, transporters, and supply chain stakeholders, enabling faster and more reliable logistics operations.',
    tags: ['Logistics', 'Mobile App', 'Management'],
    image: 'images/logos/twi.png',
    link: 'https://trukkify.ai/en',
  },
];

export default function Projects() {
  useEffect(() => {
    const observerOptions = { root: null, rootMargin: '0px', threshold: 0.12 };

    const handleIntersect = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.isVisible);
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);
    const revealElements = document.querySelectorAll('[data-reveal]');
    revealElements.forEach((el) => observer.observe(el));

    return () => revealElements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div className={styles.page}>
      <section className={styles.header}>
        <div className={`container ${styles.headerInner}`}>
          <div className={styles.reveal} data-reveal>
            <h1 className="section-title">
              Some Recent Projects
              <span className={styles.titleAccent} />
            </h1>
          </div>
        </div>

        <div className={`${styles.sectionWave} ${styles.waveToLight}`} aria-hidden="true">
          <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
            <path d="M0,0 C480,100 960,0 1440,80 L1440,100 L0,100 Z" />
          </svg>
        </div>
      </section>

      <section className={styles.featured}>
        <div className="container">
          <div className={`${styles.featuredCard} ${styles.reveal}`} data-reveal>
            <div className={styles.featuredVisual}>
              <img
                src={projects[0].image}
                alt={projects[0].title}
                className={styles.featuredImage}
              />
            </div>

            <div className={styles.featuredText}>
              <span className={styles.tag}>Featured</span>
              <h2>{projects[0].title}</h2>
              <p>{projects[0].description}</p>
              <div className={styles.tagRow}>
                {projects[0].tags.map((t) => (
                  <span key={t} className={styles.techTag}>
                    {t}
                  </span>
                ))}
              </div>
              <a href={projects[0].link} className={styles.exploreBtn}>
                Explore Project <span className={styles.linkArrow}>→</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.grid}>
        <div className="container">
          <div className={styles.cardsGrid}>
            {projects.slice(1).map((p, i) => (
              <div
                key={p.title}
                className={`${styles.card} ${styles.reveal}`}
                data-reveal
                style={{ transitionDelay: `${i * 0.07}s` }}
              >
                <div className={styles.cardVisual}>
                  <img src={p.image} alt={p.title} className={styles.cardImage} />
                </div>

                <div className={styles.cardBody}>
                  <h3>{p.title}</h3>
                  <p>{p.description}</p>
                  <div className={styles.tagRow}>
                    {p.tags.map((t) => (
                      <span key={t} className={styles.techTag}>
                        {t}
                      </span>
                    ))}
                  </div>
                  <a href={p.link} className={styles.exploreBtn}>
                    Explore Project <span className={styles.linkArrow}>→</span>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}